var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM11.1911 9.80891C10.9593 9.56887 10.831 9.24738 10.8339 8.91367C10.8368 8.57997 10.9706 8.26075 11.2066 8.02478C11.4426 7.7888 11.7618 7.65495 12.0955 7.65205C12.4292 7.64915 12.7507 7.77744 12.9907 8.00927L18.0816 13.1002C18.3202 13.3389 18.4543 13.6625 18.4543 14C18.4543 14.3375 18.3202 14.6611 18.0816 14.8998L12.9907 19.9907C12.7507 20.2226 12.4292 20.3508 12.0955 20.3479C11.7618 20.345 11.4426 20.2112 11.2066 19.9752C10.9706 19.7393 10.8368 19.42 10.8339 19.0863C10.831 18.7526 10.9593 18.4311 11.1911 18.1911L15.3822 14L11.1911 9.80891Z",
    fill: "#000A18"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackChevron);
export default __webpack_public_path__ + "static/media/blackChevron.d7c2c3435f0359409535d591431bce74.svg";
export { ForwardRef as ReactComponent };